import { CampaignArgs, QueueArgs, AgentArgs} from "../../public/scripts/diamond-api.min.js";

// DATA FOR DIAMOND ARG OBJECTS
export default {
    state: () => ({
      campaignArgs: new CampaignArgs(),
      queueArgs: new QueueArgs(),
      agentArgs: new AgentArgs(),
    }),
    mutations: {
      setAgentArgsFromJSON: (state, data) => state.agentArgs = AgentArgs.fromJSON(data),
      setCampaignArgsFromJSON: (state, data) => state.campaignArgs = CampaignArgs.fromJSON(data),
      setQueueArgsFromJSON: (state, data) => state.queueArgs = QueueArgs.fromJSON(data),
      resetArgs: (state) => {
        state.campaignArgs = new CampaignArgs();
        state.queueArgs = new QueueArgs();
        state.agentArgs = new AgentArgs();
      }
    },
    getters: {
      campaignArgs: (state) => state.campaignArgs,
      queueArgs: (state) => state.queueArgs,
      agentArgs: (state) => state.agentArgs,
    }
  }